//Yoast Faq Code
var yoastfaq = (function () {
    const faqExists = document.querySelector( '.schema-faq-section' );
    const faqQuestions = Array.prototype.slice.call(document.querySelectorAll('.schema-faq-question'));
  
    function init() {
  
      if (faqExists) {
        bindUI(faqExists);

      }
    }
  
    function bindUI() {

        for (var i = 0, len = faqQuestions.length; i < len; i++) {
          faqQuestions[i].setAttribute('tabindex', '0');
          faqQuestions[i].addEventListener("keyup", logKey);
          faqQuestions[i].addEventListener("click", logClick);
          
        }

      //faqQuestions[0].addEventListener('click', bindEvents(faqQuestions), false);

    }
      
    function logKey(e) {
      if (e.key === 'Enter')  {
        e.srcElement.classList.toggle('faq-active');
        e.srcElement.nextElementSibling.classList.toggle('faq-active');
      }

    }

    function logClick(e) {
      
        //console.log(e.srcElement.parentNode);
        if (e.srcElement.classList.contains('schema-faq-question')) {

          e.srcElement.classList.toggle('faq-active');
          e.srcElement.nextElementSibling.classList.toggle('faq-active');

        } else {
          e.srcElement.parentNode.classList.toggle('faq-active');
          e.srcElement.parentNode.nextElementSibling.classList.toggle('faq-active');
        }
        

    }

    
  
    init();
  
    return self;
  
  }());